import React from "react";

const badgeStyle = {
	display: "inline-flex",
	alignItems: "center",
	justifyContent: "center",
	padding: "9px 22px",
	borderRadius: 999,
	fontSize: 15,
	fontWeight: 700,
	letterSpacing: "0.06em",
	textTransform: "uppercase",
	color: "#f0f4ff",
	background: "linear-gradient(135deg, #3b82f6 0%, #6366f1 52%, #8b5cf6 100%)",
	boxShadow: "0 4px 16px rgba(59, 130, 246, 0.38), inset 0 1px 0 rgba(255, 255, 255, 0.22)",
	border: "1px solid rgba(255, 255, 255, 0.18)"
};

const StatBadge = () => (
	<div style={{display: "flex", justifyContent: "center", width: "100%", padding: "4px 0 12px"}}>
		<span style={badgeStyle}>Статистика</span>
	</div>
);

export default StatBadge;
